<template>
  <b-form-group
    :invalid-feedback="firstErrorMessage"
    :state="isValid"
    :class="{
      'form-group-dynamic-label': !staticLabel,
      'form-group-with-icon': icon
    }"
  >
    <slot name="label" v-if="staticLabel">
      <label>{{ label }}</label>
    </slot>
    <slot name="toggle-icon" />
    <slot 
      :errors="activeErrors" 
      :has-errors="hasErrors" 
      :first-error-message="firstErrorMessage" 
      :attrs="{ 
        ...(!isValid && { state: isValid }), 
        ...(hasValue && { 'has-value': 'true' })
      }" 
      :delayedListeners="{
        blur: (value) => {
          updateValue(value);
          preferredValidator.$touch();
        }
      }"
      :listeners="{
        input: (value) => {
          updateValue(value);
          validatorTouch();
        }
      }"
    />
    <slot name="label" v-if="!staticLabel">
      <label>{{ label }}</label>
    </slot>
    <svg-icon 
      v-if="icon" 
      class="form-group-icon" 
      :name="icon" 
    />
    </b-form-group>
</template>
<script>
import { singleErrorExtractorMixin } from "vuelidate-error-extractor";

export default {
  extends: singleErrorExtractorMixin,
  props: {
    staticLabel: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      hasValue: false
    }
  },
  mounted() {
    if (this.$attrs.value) {
      this.updateValue(this.$attrs.value);
    }
  },
  methods: {
    updateValue(value) {
      if (value.target) {
        value = value.target.value;
      }

      this.hasValue = value && value.length > 0;
    },

    validatorTouch() {
     if (typeof(this.preferredValidator.$touch) == "function")
        this.preferredValidator.$touch();
    }
  }
};
</script>